module.exports = __webpack_public_path__ + "static/media/29DUNON5.3ed66cd5.jpg";